import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { getQueryTimeoutMs } from '#pplx/frontend/api-clients/core/utils.js';
import { WEB_VERSION } from '#pplx/frontend/components/utils/consts.js';
import { spacesClient } from '#pplx_generated/typespec/rest/spaces/client.js';
export const listSpacesLandingV2 = async ({ params, reason, }) => {
    const { data, error, response } = await spacesClient.GET('/rest/spaces/landing/v2', reason, {
        params: {
            query: {
                limit: params.limit,
                cursor: params.cursor,
                search_term: params.searchTerm,
                sections: params.sections,
                ordered: params.ordered,
                version: WEB_VERSION,
            },
        },
        timeoutMs: getQueryTimeoutMs(),
    });
    if (error || !data) {
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            message: 'Failed to fetch spaces landing v2',
            cause: error,
            status: response.status ?? 0,
        });
    }
    return data;
};
//# sourceMappingURL=listSpacesLandingV2.js.map